/**
 * Static API Endpoints. 
 * These values rarely change and if they do it is a structural change
 * No need for environment variables. 
 */
export default class ApiEndpoints {

    static LOGIN = "/login";
    static LOGOUT = "/logout";
    static NAVIGATION_ITEMS = "/api/navigation-items";
    static PAGES = "/api/pages";
    static ARTICLE_COLLECTION = "/api/articles";
    static ARTICLE_CATEGORY_COLLECTION = "/api/article-categories";
    static USER_SAVE = "/api/users";
    static PRODUCER_COLLECTION = "/api/producers";
    static PRODUCER_ADDRESS = "/api/producer-addresses";
    static QUALITY_COMPONENTS = "/api/quality-components";
    static HISTORICAL_QUALITY_COMPONENTS = "/api/historical-quality-components";
    static COOP_PRICE_HISTORY = "/api/coop-price-histories";
    static COOP_PRICE_PROJECTION = "/api/coop-price-projections";
    static MONTANA_PRICE_HISTORY = "/api/montana-price-histories";
    static MONTANA_PRICE_PROJECTION = "/api/montana-price-projections";
    static ALERTS_COLLECTION = "/api/alerts";
    static WEIGHTED_AVERAGES = "/api/weighted-averages";
    static EVENT_COLLECTIONS = "/api/events";
    static CONTACT_FORM_EMAIL = "/api/send_message";
    static BLUE_DOT_REPORT = "/api/blue-dots";
    static RESET_PASSWORD = "/api/send_reset_password_email";
    static VALIDATE_JWT = "/api/validate_jwt";
    static ADDRESS_UPDATE_NOTIFICATION = "/api/address_update_notification";
    static TWO_FACTOR_SEND = "/api/send";
    static TWO_FACTOR_VERIFY = "/api/verify";
    static REGISTRATION_TWO_FACTOR_SEND = "/api/registration-send-code";
    static REGISTRATION_TWO_FACTOR_VERIFY = "/api/registration-verify-code";
    static FE_USER_ROLE = "/api/fe-user-roles";
    static USER_FPU_ACCESS_SAVE = "/api/user-fpu-accesses";
    static REGISTER_USER = "/api/register";
    static USER_RESEND_INVITE = "/api/resend_registration_email";
    static REVOKE_USER = "/api/delete";
    static USER_REGISTRATION = "/api/users/{0}/register_user";
    static NOTIFICATIONS = "/api/notifications";
    static CHART_NOTIFICATION_SETTING = "/api/chart-notification-settings";
    static USER_NOTIFICATION_SETTINGS = "/api/user-notification-settings";
    static PAGE_ROUTES = "/api/routes";
    static DASHBOARD_NEWS = "/api/dashboard-news";
    static DASHBOARD_DATA = "/api/dashboard-datas";
    static USER_UPDATE_QC_SMART_SETTINGS = "/api/users/{id}/update_qc_smart_settings";

    static SMART_TEST_REPORT = "/api/smart-test-results";
    static DEGRADES_REPORT = "/api/degrades";
    static MEMBER_EQUITY_REPORT = "/api/member-equities";
    static OPEN_CONTRACTS = "/api/open-contracts";
    static CLOSED_CONTRACTS = "/api/closed-contracts";
    static DAILY_AVERAGE_PRODUCTION = "/api/daily-average-productions";
    static PAYROLL_LIST = "/api/payroll-headers";
    static PAYROLL_DETAILS = "/api/payroll-lines";
    static DDC_PAYROLL_HEADERS = '/api/payroll-header-d-d-cs';
    static DDC_PAYROLL_REPORT = '/api/d-d-c-payroll-reports'
    static TABLE_UPDATES = "/api/data-table-date-stamps";
    static REPORT_PDF = "/api/report-pdfs";
    static EZ_FEED_WSDL_URL = process.env.EZ_FEED_URL;
    static CHART_AVERAGES = "/api/chart-averages";
    static CHART_METRICS = "/api/chart-metrics";
    static ANNUAL_MEETING_REG = "/api/annual-meeting-registrations";
}